export type NextAnimationFrame = {
  linear: number;
  eased: number;
  progress: number | null;
};

export function getNextAnimationFrame(
  position: number,
  from: number,
  to: number,
  duration: number,
  easeFn: Function
) {
  const result: NextAnimationFrame = {
    linear: to,
    eased: to,
    progress: null
  };

  // if nothing to interpolate
  if (from !== to) {
    const range = Math.abs(to - from);
    const step = range / (duration / 16.66); // ~60fps

    const direction = to > from ? 1 : -1;

    const nextPosition = position + step * direction;
    const percent = Math.min(1, Math.abs(nextPosition - from) / range);

    const easedPercent = easeFn(percent);

    const newDistance = range * percent;
    const newDistanceEased = range * easedPercent;

    result.linear = percent < 1 ? from + direction * newDistance : to;
    result.eased = percent < 1 ? from + direction * newDistanceEased : to;
    result.progress = percent;
  }

  return result;
}
